import resume from '../assets/pdf/resume.pdf'
import profile from '../assets/png/profile.jpeg'

export const headerData = {
    name: 'Aidan Armstrong',
    title: "Software Engineer",
    desciption:"If you go back a few hundred years, what we take for granted today would seem like magic-being able to talk to people over long distances, to transmit images, flying, accessing vast amounts of data like an oracle. These are all things that would have been considered magic a few hundred years ago.",
    image: profile,
    resumePdf: resume
}
